import { render, staticRenderFns } from "./WebhookForm.vue?vue&type=template&id=15e9bd6c&scoped=true&"
import script from "./WebhookForm.vue?vue&type=script&lang=js&"
export * from "./WebhookForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e9bd6c",
  null
  
)

export default component.exports